import { CrnJobFormProps } from "../types";

export const cronJobValidationScheme = (values : CrnJobFormProps) => {
  let errors :any= {};

  const {paymentCronVisible, customerCronVisible, customerStartDate, 
      customerWorkPeriod, customerWorkType, paymentStartDate, paymentWorkPeriod,
      paymentWorkType, customerStatus, paymentStatus} = values;

  if (paymentCronVisible && paymentStatus) {
      if (!paymentStartDate) {
          errors.paymentStartDate = "Geçerli bir tarih giriniz";
      }
      if (!paymentWorkPeriod) {
          errors.paymentWorkPeriod = "Geçerli bir Çalışma Periyodu giriniz";
      }
      if (!paymentWorkType) {
          errors.paymentWorkType = "Geçerli bir Çalışma Tipi giriniz";
      }
  }
  
  if (customerCronVisible && customerStatus) {
      if (!customerStartDate) {
          errors.customerStartDate = "Geçerli bir tarih giriniz";
      }
      if (!customerWorkPeriod) {
          errors.customerWorkPeriod = "Geçerli bir Çalışma Periyodu giriniz";
      }
      if (!customerWorkType) {
          errors.customerWorkType = "Geçerli bir Çalışma Tipi giriniz";
      }
  }
  return errors;
};
